import React from "react";

export const defaultAwarenessData = [
  { totalPrograms: "", topics: "", coverage: "" },
];

const AwarenessProgramTable = ({ awarenessData, setAwarenessData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...awarenessData];
    updated[index][field] = value;
    setAwarenessData(updated);
  };

  const addRow = () => {
    setAwarenessData([
      ...awarenessData,
      { totalPrograms: "", topics: "", coverage: "" },
    ]);
  };

  const removeRow = () => {
    if (awarenessData.length > 1) {
      setAwarenessData(awarenessData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    verticalAlign: "top",
    textAlign: "left",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const textareaStyle = {
    ...inputStyle,
    height: "80px",
    resize: "vertical",
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <colgroup>
          <col style={{ width: "10%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "40%" }} />
          <col style={{ width: "25%" }} />
        </colgroup>
        <thead>
          <tr>
            <th style={header}>S. No</th>
            <th style={header}>Number of awareness programs</th>
            <th style={header}>
              Topics / principles covered under training program
            </th>
            <th style={header}>% of value chain partners covered by program</th>
          </tr>
        </thead>
        <tbody>
          {awarenessData.map((row, index) => (
            <tr key={index}>
              <td style={{ ...cell, textAlign: "center", fontWeight: "bold" }}>
                {index + 1}.
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.totalPrograms}
                  onChange={(e) =>
                    handleChange(index, "totalPrograms", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <textarea
                  placeholder="Topics"
                  value={row.topics}
                  onChange={(e) =>
                    handleChange(index, "topics", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="%"
                  value={row.coverage}
                  onChange={(e) =>
                    handleChange(index, "coverage", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default AwarenessProgramTable;
